<template>
  <div>
    <basic-container>
      <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
        @search-change="searchChange" @refresh-change="refreshChange(page)" @search-reset="searchClear"
        @row-save="handleSave" @row-update="handleUpdate" @size-change="pageSizeChange" @current-change="pageChange">
        <template slot="searchMenu"></template>
        <template slot="search"></template>
        <template slot-scope="scope" slot="menuLeft">
          <el-button type="primary" icon="el-icon-printer" size="small" plain @click.stop="printJson()">打印</el-button>
          <el-button type="success" icon="el-icon-download" size="small" plain
            @click.stop="downloadExcelexportStockDetail">下载Excel</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
          <el-button type="success" icon="el-icon-view" size="small" plain
            @click.stop="serviceListing(scope.row)">查看库存</el-button>
        </template>
      </avue-crud>
    </basic-container>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { stockMonitorOption } from "@/const/salesCloud/stockMonitorOption";
import {
  immediatePay,
  downloadExcelStockMonitor
} from "@/api/salesCloud/workOrder";
import { wxNativePayQuery } from "@/api/salesCloud/depositRecharge";
import {
  InvoiceSystemV2Statistics,
  InvoiceSystemV2StatisticsDownload
} from "@/api/salesCloud/credit";
import { DIC } from "@/const/dic";
import { excelaxios } from "@/util/excelaxios";
import VueQr from "vue-qr";
import { getCompany } from "@/util/auth";
import { formatterDateToUTC, parseStatus } from "@/util/util";
import { exportExcel } from "xlsx-oc";
export default {
  name: "stockMonitor",
  components: {
    VueQr
  },
  data() {
    return {
      tableOption: stockMonitorOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      tableLoading: false,
      eleDialog: false,
      serviceCategoryId: "",
      serviceItemId: "",
      payTime: {},
      from: {
        text: "text"
      },
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      },
      users: [],
      userType: "JOINS_ENGINEER",
      point: {},
      serviceCategorys: [],
      serviceCategory: {},
      joinsWorkServiceItems: [],
      workOrderStatus: DIC.WORK_ORDER_STATUS,
      QRCodeDialog: false,
      config: {},
      evaluateDialog: false,
      score: 5,
      clues: [],
      evaluateObj: {},
      serviceItem: {}
    };
  },
  created() {
    this.handleList();
  },
  watch: {},
  mounted() { },
  computed: {
    ...mapGetters(["permission"])
  },
  props: [],
  methods: {
    handleAgree() {
      console.log("同意退货");
      this.$message("同意");
    },
    stockRemovalSubmit() {
      console.log(this);
    },
    handleDialog(row, index) {
      this.stockSuperviseDialog = true;
      // this.evaluateDialog =true
      this.formobj = row;
      console.log(row, index);
    },
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = pageSize;
      this.downloadData = params;
      InvoiceSystemV2Statistics(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      this.downloadData = params;
      InvoiceSystemV2Statistics(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchClear() {
      // this.$refs.crud.$refs.searchForm.resetFields();
      this.serviceCategory = "";
      this.serviceCategoryId = "";
      this.serviceItem = "";
      this.serviceItemId = "";
      console.log(this);
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      if (
        null != params.startDate_endDate &&
        undefined != params.startDate_endDate &&
        "" != params.startDate_endDate
      ) {
        params.startTime = params.startDate_endDate[0];
        params.endTime = params.startDate_endDate[1];
      } else {
        params.startTime = "";
        params.endTime = "";
      }
      // console.log(this.$refs.crud.resetForm)
      this.downloadData = params;
      console.log(params);
      console.log(this);
      InvoiceSystemV2Statistics(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      });
    },
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      this.downloadData = params;
      InvoiceSystemV2Statistics(params).then(res => {
        let data = JSON.parse(res.data);
        console.log(res);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },

    handleDetail(row, index) { },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd() {
      this.point = {};
      this.serviceCategory = {};
      this.joinsWorkServiceItems = [];
      this.$refs.crud.rowAdd();
    },
    handleEdit(row, index) {
      this.workerUser = {};
      this.serviceCategory.id = row.serviceCategoryId;
      this.choseWorkServiceItem();
      this.workerUser.id = row.workerUserId;
      let location = {};
      console.log("集合：" + JSON.stringify(row));
      location.lng = row.longitude;
      location.lat = row.latitude;
      this.point.location = location;
      this.point.pname = row.province;
      this.point.cityname = row.city;
      this.point.adname = row.area;
      this.$refs.crud.rowEdit(row, index);
    },
    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      this.downloadData = params;
      InvoiceSystemV2Statistics(params).then(res => {
        let data = JSON.parse(res.data);
        console.log("handlelist", res);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      done();
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(row, index, done) {
      done();
    },
    immediatePayment(row) {
      this.config.value = "";
      let obj = {};
      obj.id = row.id;
      immediatePay(obj).then(response => {
        this.tableLoading = false;
        if (response.code == "200") {
          let data = response.data;
          wxNativePayQuery(data.outTradeNo).then(res => {
            console.log(res);
            if (res.code == "200") {
              if (res.data == "SUCCESS") {
                let _this = this;
                setTimeout(function () {
                  _this.QRCodeDialog = false;
                  _this.$message({
                    showClose: true,
                    message: "支付成功",
                    type: "success"
                  });
                  _this.handleList();
                }, 1000);
              } else {
                this.QRCodeDialog = false;
                this.$message({
                  showClose: true,
                  message: "支付超时",
                  type: "error"
                });
              }
              //this.handleList();
            } else {
              this.QRCodeDialog = false;
              this.$message({
                showClose: true,
                message: "支付超时",
                type: "error"
              });
              this.handleList();
            }
          });
          let start = new Date().getTime();
          while (true) if (new Date().getTime() - start > 1) break;
          this.config.value = "";
          this.config.value = data.codeUrl;
          console.log("集合：" + this.config.value);
          this.QRCodeDialog = true;
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error"
          });
          done();
          this.$refs.crud.rowAdd();
          return;
        }
        // let data = JSON.parse(res.data);
      });
    },
    serviceListing(row) {
      this.$router.push({
        name: "商户库存详情",
        params: { id: row.id }
      });
      console.log(row);
    },
    formmaterImage(row) {
      let str = new Array();
      console.log("row：" + JSON.stringify(row));
      if (row != null) {
        let picArray = row.split(",");
        for (let i = 0; i < picArray.length; i++) {
          // console.log("url："+ row[i].url)
          str.push(picArray[i]);
        }
      }
      return str;
    },
    downloadExcelexportStockDetail() {
      // let params = this.downloadData;
      // let url = `/joins-invoice-system/v1/credit/exportCredit?`;
      // // params.excelName = "qwe.xsl";
      // excelaxios(url, params);
      let params = this.downloadData;
      InvoiceSystemV2StatisticsDownload(params).then(res => {
        window.open(res);
      });
      // delete params.page;
      // params.size = this.page.total;
      // InvoiceSystemV2Statistics(params).then(res => {
      //   let data = JSON.parse(res.data);
      //   const list = data.rows;
      //   for (let i of list) {
      //     i.clearingType = parseStatus(DIC.FINANCIAL_STATUS, i.clearingType);
      //     i.lastPurchaseTime = formatterDateToUTC(i.lastPurchaseTime * 1);
      //     i.residueDegree = i.residueDegree == null ? 0 : i.residueDegree;
      //     i.fluffMoney = i.fluffMoney == null ? 0 : i.fluffMoney;
      //   }
      //   const header = [];
      //   for (let i of this.tableOption.column) {
      //     const obj = {};
      //     if (i.prop == "payTimeInterval" || i.prop == "startDate_endDate") {
      //       ("");
      //     } else {
      //       obj.k = i.prop;
      //       obj.v = i.label;
      //       header.push(obj);
      //     }
      //   }
      //   const fileName = "商户库存云监控.xlsx";
      //   exportExcel(header, list, fileName);
      // });
    },
    printJson() {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      this.downloadData = params;
      InvoiceSystemV2Statistics(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        let someJSONdata = data.rows;
        someJSONdata = someJSONdata.map(item => {
          console.log(item.maps);
          item.lastPurchaseTime = item.lastPurchaseTime
            ? formatterDateToUTC(item.lastPurchaseTime)
            : "";

          /* if (item.clearingType == "CASH") {
            item.clearingType = "现款现货";
          } else {
            item.clearingType = "月结";
          }
          if (item.fluffMoney) {
            item.fluffMoney;
          } else {
            item.fluffMoney = 0;
          } */
          return item;
        });
        this.tableLoading = false;
        let s = formatterDateToUTC(new Date().getTime());
        let c = getCompany();
        printJS({
          printable: someJSONdata,
          header: `<div style='position:absolute;bottom:0;display:flex;flex-flow: row nowrap;width:100%; justify-content: space-between;'><div>打印时间：${s}</div><div style="margin-right:15px;">${c}</div></div>`,
          properties: [
            { field: "account", displayName: "账号" },
            { field: "shopName", displayName: "店铺名称" },
            { field: "name", displayName: "法人名称" },
            { field: "shopAddress", displayName: "店铺地址" },
            { field: "lastPurchaseTime", displayName: "上次采购时间" },
            { field: "number", displayName: "现有库存" },
            { field: "totalNumber", displayName: "总库存" },
            // { field: "waitPayPrice", displayName: "未结算金额" }
          ],
          targetStyles: "width:200px",
          gridHeaderStyle:
            "border: 1px solid  lightgray;white-space:nowrap;padding:0px 8px;text-align:center ",
          gridStyle:
            "border: 1px solid lightgray;white-space:nowrap;padding:8px 10px ;text-align:center",
          type: "json"
        });
      });
    }
  }
};
</script>

<style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
